import { render, staticRenderFns } from "./vTable.vue?vue&type=template&id=b261b7e2"
import script from "./vTable.vue?vue&type=script&lang=js"
export * from "./vTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports